import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_VDOSETTOPIC,
  GET_VDOSETTOPICS,
  GET_VDOSETTOPICS_BY_FILTER,
  ADD_VDOSETTOPIC,
  UPDATE_VDOSETTOPIC,
  DELETE_VDOSETTOPIC,
  DELETE_ONLY_VIDEO, UPDATE_ONLY_VDOSETTOPIC
} from '@/queries/modules/vdoSet/vdoSetTopic.js';
import {
  GET_REUSABLE_VDOSETTOPICS,
  BORROW_VDOSETTOPIC_VIDEO,
  GET_VDOSETTOPIC_SHARING,
} from '@/queries/modules/vdoSet/vdoSetVideoReuse.js';

export async function getVdoSetTopics(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETTOPICS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoSetTopics', data.getVdoSetTopics);
      context.commit('setSuccess', null);
      return data.getVdoSetTopics
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoSetTopicsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETTOPICS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoSetTopics', data.getVdoSetTopicsByFilter);
      context.commit('setSuccess', null);

      return data.getVdoSetTopicsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETTOPIC,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setVdoSetTopic', data.getVdoSetTopic);
      context.commit('setSuccess', null);
      return data.getVdoSetTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_VDOSETTOPIC,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const vdoSetTopics = [...context.state.vdoSetTopics];
      vdoSetTopics.push(data.addVdoSetTopic);
      context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', newItemSuccess(data.addVdoSetTopic.nameLocal));

      return data.addVdoSetTopic;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_VDOSETTOPIC,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.vdoSetTopics.findIndex(item => item.id === data.updateVdoSetTopic.id);
      const vdoSetTopics = [
        ...context.state.vdoSetTopics.slice(0, index),
        data.updateVdoSetTopic,
        ...context.state.vdoSetTopics.slice(index + 1)
      ];
      context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', updateItemSuccess(data.updateVdoSetTopic.nameLocal));

      return data.updateVdoSetTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateOnlyVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_ONLY_VDOSETTOPIC,
        variables: payload,
      });

    const {data, errors} = await result;
    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      // const index = context.state.vdoSetTopics.findIndex(item => item.id === data.updateVdoSetTopic.id);
      // const vdoSetTopics = [
      //   ...context.state.vdoSetTopics.slice(0, index),
      //   data.updateVdoSetTopic,
      //   ...context.state.vdoSetTopics.slice(index + 1)
      // ];
      // context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', updateItemSuccess(data.updateOnlyVdoSetTopic.nameLocal));

      return data.updateOnlyVdoSetTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_VDOSETTOPIC,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else if(data && data.deleteVdoSetTopic){
      const index = context.state.vdoSetTopics.findIndex(item => item.id === data.deleteVdoSetTopic.id);
      const vdoSetTopics = [
        ...context.state.vdoSetTopics.slice(0, index),
        ...context.state.vdoSetTopics.slice(index + 1)
      ];
      context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', deleteItemSuccess(data.deleteVdoSetTopic.nameLocal));

      return data.deleteVdoSetTopic
    }else{
      context.commit('setProcessing', false);
      return null
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteOnlyVideo(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_ONLY_VIDEO,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else if(data && data.deleteOnlyVideo){
      const index = context.state.vdoSetTopics.findIndex(item => item.id === data.deleteOnlyVideo.id);
      const vdoSetTopics = [
        ...context.state.vdoSetTopics.slice(0, index),
        data.updateVdoSetTopic,
        ...context.state.vdoSetTopics.slice(index + 1)
      ];
      context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', deleteItemSuccess(data.deleteOnlyVideo.nameLocal));

      return data.deleteOnlyVideo
    }else{
      context.commit('setProcessing', false);
      return null
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

// The picker's search fires on every "Search" click and every reopen of
// BorrowVideoDialog. It renders into that dialog, which sits on top of this
// screen -- committing setProcessing(true) here flashed the full-screen
// Loader on the screen behind the dialog on every search, for a result the
// dialog itself is already the one rendering. Same abstention as
// getVdoSetTopicSharing below, for the same reason: this is a sidecar fetch
// for a dialog's own list, not a user-initiated action against the shared
// processing/error/success state. borrowVdoSetTopicVideo is different -- it
// is the user's committing action, so it keeps participating and the Loader
// is wanted there.
export async function getReusableVdoSetTopics(context, payload) {
  try {
    const {data, errors} = await apolloClient.query({
      query: GET_REUSABLE_VDOSETTOPICS,
      variables: {filter: payload},
      fetchPolicy: 'network-only',
    });

    if (errors) {
      console.error(errors); // eslint-disable-line no-console
      return [];
    }
    return data.getReusableVdoSetTopics;
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
    return [];
  }
}

export async function borrowVdoSetTopicVideo(context, payload) {
  context.commit('setProcessing', true);
  try {
    const {data, errors} = await apolloClient.mutate({
      mutation: BORROW_VDOSETTOPIC_VIDEO,
      variables: {
        targetVdoSetTopicId: payload.targetVdoSetTopicId,
        sourceVdoSetTopicId: payload.sourceVdoSetTopicId,
      },
    });

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    }

    // borrowVdoSetTopicVideo is non-null in the schema and has no refuse
    // signal -- unlike the delete mutations, every rejection it can make
    // throws and arrives above as `errors`. So reaching here means the
    // mutation succeeded and the topic is present.
    context.commit('setVdoSetTopic', data.borrowVdoSetTopicVideo);
    context.commit('setSuccess', updateItemSuccess(data.borrowVdoSetTopicVideo.nameLocal));
    return data.borrowVdoSetTopicVideo;
  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

// Kept separate from getVdoSetTopic because it is the only document that asks
// for videoSharedWith, which costs one extra query per call on the server.
//
// This is a sidecar enrichment fetch, not a user-initiated action: it fires
// every time the admin selects a different topic, purely to populate an
// informational banner ("borrowed from X" / "also used by N others"). It
// deliberately does not touch the shared processing/error/success state:
// committing setProcessing(true) here would flash the full-screen Loader on
// every topic click, and committing setError on failure would stomp the
// shared state of whatever real (user-initiated) action is in flight on the
// same screen. On any failure -- GraphQL errors or a thrown exception -- log
// it and return null; the UI simply skips rendering the sharing banner.
export async function getVdoSetTopicSharing(context, payload) {
  try {
    const {data, errors} = await apolloClient.query({
      query: GET_VDOSETTOPIC_SHARING,
      variables: {id: payload.id},
      fetchPolicy: 'network-only',
    });

    if (errors) {
      console.error(errors); // eslint-disable-line no-console
      return null;
    }
    return data.getVdoSetTopic;
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
    return null;
  }
}

